var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.booking.timetableBlockPrice.name))]),_c('div',{staticClass:"time-style"},[_vm._v(" "+_vm._s(_vm.startAt)+" - "+_vm._s(_vm.endAt)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }